import { renderReactWithStyledComponents } from '../helpers/renderComponent';
import GiftApp from '../routes/GiftCertificate';

import '../styles/pages/gift_page.scss';

export default renderReactWithStyledComponents('GiftApp', GiftApp);
